export const AppActions = {
  SET_ATTRIBUTE: "APP_SET_ATTRIBUTE"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setAppAttribute = (key, value) => {
  return {
    type: AppActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const setLoading = (state) => (dispatch, getState) => {
  let timer = getState().app.timer;
  if( state ) {
    if( ! timer ) {
      timer = setTimeout( () => {
        dispatch( setAppAttribute('loading', true) );
      }, 400);
      dispatch( setAppAttribute('timer', timer) );
    }
  } else {
    if( timer ) {
      clearTimeout(timer);
      dispatch( setAppAttribute('timer', null) );
    }
    dispatch( setAppAttribute('loading', false) );
  }
}
